<template>


  <v-container fluid ma-0 pa-0 fill-height>
    <v-navigation-drawer
     v-model="drawer"
     app
     width="50%"

   >
   <SvgPanZoom
    id="panZoom"
style="width: 100%; height: 100%;"
:zoomEnabled="true"
:controlIconsEnabled="true"
:fit="false"
:center="true"
:key="key"
>

  <svg  id="mySvg" width="100%" height="100%"  >
      <defs>
        <mask id="stripe">

 </mask>
         <filter id="f1" x="0" y="0">
           <feGaussianBlur in="SourceGraphic" stdDeviation="15" />
         </filter>

       </defs>
         <image  filter="url(#f1)" v-if="meta.file"   :xlink:href="base_url+place+'/'+meta.file" id="img_canvas" :height="img_dim.h" :width="img_dim.w"/>

         <template v-if="!meta.course">

          <line  v-for="(c,i) in data.controls" v-show="started" class="control_line"  :stroke-width="6 * meta.ratio" :key="'line_'+i" :x1="coord('x1', c, data.controls[i + 1])" :y1="coord('y1', c, data.controls[i + 1] )" :x2="coord('x2', c, data.controls[i + 1])" :y2="coord('y2', c, data.controls[i + 1])" stroke="purple" />


        <template v-if="data.start && data.controls" >
        <line  v-show="started" class="control_line"  :stroke-width="6 * meta.ratio" key="line_" :x1="coord('x1', data.start, data.controls[0])" :y1="coord('y1', data.start, data.controls[0] )" :x2="coord('x2', data.start, data.controls[0])" :y2="coord('y2', data.start, data.controls[0])" stroke="purple" />
      </template>
        <template v-for="(c,i) in data.controls" >
          <circle  v-show="started" class="control_circle"    :key="'c_'+i" :cx="c.geo.x" :cy="c.geo.y" :r="40 * meta.ratio " stroke="purple" :stroke-width="6 * meta.ratio" fill-opacity="0" />

          <text   v-show="started" :key="'t_'+i" :x="textPos('x',c)" :y="textPos('y',c)" :font-size="60 * meta.ratio" fill="purple" stroke="white" :stroke-width="2 * meta.ratio " >{{ c.order }}</text>
        </template>
          <circle  v-show="started" v-if="data.finish" :cx="data.finish.geo.x" :cy="data.finish.geo.y" :r="40 * meta.ratio" stroke="purple" :stroke-width="6 * meta.ratio" fill-opacity="0" />
          <circle v-show="started"  v-if="data.finish" :cx="data.finish.geo.x" :cy="data.finish.geo.y" :r="30 * meta.ratio" stroke="purple" :stroke-width="6 * meta.ratio" fill-opacity="0" />
  <polygon v-if="data.start" v-show="started" :points="getStartPoint()" stroke="purple" :stroke-width="6 * meta.ratio" fill-opacity="0" />






</template>
       <text  v-if="!started" x="400" y="500"  font-size="30" fill="red">
         {{ $t('blurred_map') }}

         </text>

    </svg>
</SvgPanZoom>
 </v-navigation-drawer>

    <v-dialog v-model="dialogRes" max-width="700">
  <v-card :scrollable="true" max-height="80%">
    <v-card-title><v-icon class="mr-4">mdi-trophy</v-icon>{{ $t('results')}} <v-spacer></v-spacer><v-btn icon @click="dialogRes = false;"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
<v-divider/>
      <v-card-text class="ma-2">
         <v-simple-table :fixed-header="true">
           <thead>
                  <tr>
                    <th class="text-left">{{ $t('nickname') }}</th>
                    <th class="text-left">{{ $t('club') }}</th>
                    <th class="text-left">{{ $t('distance') }}</th>
                      <th class="text-left">{{ $t('time') }}</th>
                      <th class="text-left">{{ $t('date') }}</th>
                  </tr>

                </thead>
                <tbody>
        <tr v-for="(item,i) in rankings" :key="'rank_'+i">
          <td>{{ item.pseudo }}</td>
          <td>{{ item.club }}</td>
            <td>{{ Number(item.dist / 1000).toFixed(2) }} kms</td>
          <td>{{ item.time }} {{ $t('seconds') }}</td>
          <td>{{ item.date.toDate().toLocaleDateString() }} - {{ item.date.toDate().toLocaleTimeString() }}  </td>
        </tr>
      </tbody>
         </v-simple-table>
      </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFinish">
      <v-card tile v-if="finished">
        <v-card-title><v-icon class="mr-4">mdi-trophy</v-icon>{{ $t('congrats') }} <v-spacer></v-spacer><v-btn icon @click="dialogFinish = false;"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
        <v-divider/>
        <v-card-text class="ma-2">
        {{$t('congrats')}}, {{$t('splitimes')}}
          <p> {{ $t('start') }} : {{ (new Date(validations.start.time)).toLocaleTimeString() }}</p>
          <ul>
            <li :key="i" v-for="(v,i) in validations.controls">Poste {{ v.id }} - {{ (new Date(v.time)).toLocaleTimeString() }}</li>
          </ul>
          <p> {{ $t('finish') }} : {{ (new Date(validations.finish.time)).toLocaleTimeString() }}</p>
          <p>{{ $t('time') }} : {{ Number(race_time).toFixed(2) }} {{ $t('seconds') }}</p>
<div v-if="sendRes">
          <v-form @submit.prevent="submit">
            <v-text-field
            v-if="meta.lockdown"
            :label="$t('lockdown_bib')"
            required
            v-model="form.pseudo"
            :placeholder="$t('lockdown_bib')"
            outlined
          ></v-text-field>
          <v-text-field
          v-else
          :label="$t('nickname')"
          required
          v-model="form.pseudo"
          :placeholder="$t('nickname')"
          outlined
        ></v-text-field>
        <v-text-field
        v-if="meta.lockdown"
        :label="$t('nickname')"
        required
        v-model="form.club"
        :placeholder="$t('nickname')"
        outlined
      ></v-text-field>
          <v-text-field
          v-else
          :label="$t('club')"
          required
          v-model="form.club"
          :placeholder="$t('club')"
          outlined
        ></v-text-field>
        <v-text-field

        :label="$t('email')"
        v-model="form.email"
        :placeholder="$t('email')"
        outlined
        ></v-text-field>
        <v-btn :disabled="form.club.length == 0 || form.pseudo.length == 0" :loading="submittingRes" type="submit">{{ $t('sendResult') }}</v-btn>
          </v-form>
        </div>
        </v-card-text>
        <!--  <v-card-actions>
        <v-btn text @click="sendRes = true;">{{ $t('sendResultAndAppear') }}</v-btn></v-card-actions>-->
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogInfo">
      <v-card tile>
        <v-card-title><v-icon class="mr-4">mdi-information-outline</v-icon>{{ $t('important_information') }}<v-spacer></v-spacer><v-btn icon @click="dialogInfo = false;"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
        <v-divider/>
        <v-card-text class="ma-2">

          <p> {{ $t('p0') }} {{ meta.title }}</p>
          <p>{{ $t('pAA')}}</p>
          <div class="fb-page" data-href="https://www.facebook.com/Virtual-Orienteering-Races-OGame-101848681521990" data-tabs="" data-width="" data-height="" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="false"><blockquote cite="https://www.facebook.com/Virtual-Orienteering-Races-OGame-101848681521990" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/Virtual-Orienteering-Races-OGame-101848681521990">Virtual Orienteering Races - O&#039;Game</a></blockquote></div>
          <p v-html="$t('p1')"></p>
          <p>{{ $t('interface_helper') }}</p>
          <p><v-icon>mdi-map</v-icon> : {{ $t('icon_map') }} <v-icon>mdi-information-outline</v-icon> : {{ $t('icon_information') }}  </p>

          <p><v-icon>mdi-lighthouse</v-icon> : {{ $t('icon_lighthouse') }}  <v-icon>mdi-trophy</v-icon> :  {{ $t('icon_trophy') }}</p>
          <p><v-icon>mdi-refresh</v-icon> : {{ $t('icon_refresh') }}</p>
            <p><v-icon>mdi-swap-horizontal</v-icon> : {{ $t('icon_switch') }}</p>
            <p><v-icon>mdi-format-list-numbered</v-icon> : {{ $t('icon_list_controls') }}</p>
          <p>{{ $t('thanks') }}: <span v-html="meta.thanks"></span></p>
            <p v-html="$t('p2')"></p>
          <form target="_blank" action="https://www.paypal.com/cgi-bin/webscr" method="post">
          <input type="hidden" name="cmd" value="_donations" />
          <input type="hidden" name="business" value="QTYZQPXHZ8PNU" />
          <input type="hidden" name="currency_code" value="EUR" />
          <input type="image" :src="'https://www.paypalobjects.com/'+$t('donate_img')+''" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Bouton Faites un don avec PayPal" />
          <img alt="" border="0" src="https://www.paypal.com/fr_FR/i/scr/pixel.gif" width="1" height="1" />
          </form>
          <p>{{ $t('hire_me') }}</p>
          <p>{{ $t('feedback') }} <a href="mailto:simon.blum@hotmail.fr">Simon</a></p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
v-model="snack" :top="true" :color="snackColor">
{{ snackText }}
    </v-snackbar>

               <div id="map"></div>
            <div :style="{ 'height': '200px', 'width': '50px', 'bottom': '200px', 'left': '0px', 'position':'absolute', 'z-index': '50'}">
            <v-flex>
            <v-col>
            <v-btn  @click="drawer = !drawer;" class="mb-3" elevation="3" tile color="primary"><v-icon color="white" >mdi-map</v-icon></v-btn>
            <v-btn  @click="dialogInfo = true;" class="mb-3" elevation="3" tile color="primary"><v-icon color="white" >mdi-information-outline</v-icon></v-btn>


             <v-btn  @click="dialogRes = true;"  class="mb-3" elevation="3" tile color="primary"><v-icon color="white" >mdi-trophy</v-icon></v-btn>
             <v-btn  @click="reload" class="mb-3" elevation="3" tile color="primary"><v-icon color="white" >mdi-reload</v-icon></v-btn>

             <v-btn @click="backToStart" class="mb-3" elevation="3" tile color="primary"><v-icon color="white" >mdi-lighthouse</v-icon></v-btn>
              <v-btn  @click="drawer2 = !drawer2;" class="mb-3" elevation="3" tile color="primary"><v-icon color="white" >mdi-format-list-numbered</v-icon></v-btn>

      
            </v-col>
            </v-flex>
            </div>
               <v-btn fab color="black" :style="{'bottom': '200px', 'right': '5px', 'position':'absolute', 'z-index': '2000'}"><Compass :degrees="degree"></compass></v-btn>
               <v-navigation-drawer app v-model="drawer2" :right="true">
                 <v-app-bar
      color="primary"
      dense
      dark
    ><v-toolbar-title>{{ $t('controls') }}</v-toolbar-title></v-app-bar>
                 <v-list

       nav
       class="py-0"
     >
     <v-list-item two-line><v-list-item-icon>
         <v-icon color="purple">mdi-triangle-outline</v-icon>
       </v-list-item-icon>
         <v-list-item-content>
        <v-list-item-title >{{ $t('start') }}</v-list-item-title>
          <v-list-item-subtitle v-if="validations.start" >{{ (new Date(validations.start.time)).toLocaleTimeString() }}</v-list-item-subtitle>
      </v-list-item-content>
     </v-list-item>
     <v-list-item two-line v-for="(c,i) in data.controls" :key="'control_'+i"><v-list-item-icon>
         <v-icon color="purple">mdi-circle-outline</v-icon>
       </v-list-item-icon>
         <v-list-item-content>
        <v-list-item-title >{{ $t('control') }} #{{ c.order }}</v-list-item-title>
          <v-list-item-subtitle v-if="validations.controls[c.order -1]"> {{ (new Date(validations.controls[c.order - 1].time)).toLocaleTimeString() }}</v-list-item-subtitle>
      </v-list-item-content>
     </v-list-item>
     <v-list-item two-line><v-list-item-icon>
         <v-icon color="purple">mdi-circle-double</v-icon>
       </v-list-item-icon>
         <v-list-item-content>
        <v-list-item-title >{{ $t('finish') }}</v-list-item-title>
          <v-list-item-subtitle v-if="validations.finish" >{{ (new Date(validations.finish.time)).toLocaleTimeString() }}</v-list-item-subtitle>
      </v-list-item-content>
     </v-list-item>
   </v-list>
               </v-navigation-drawer>
      </v-container>

</template>

<script>
var svgIntersections = require('svg-intersections');
   var intersect = svgIntersections.intersect;
   var shape = svgIntersections.shape;

import Vue from 'vue'
import firebase from '@firebase/app';
import   '@firebase/firestore';
import Compass from './Compass';
import {Loader } from 'google-maps';
import SvgPanZoom from 'vue-svg-pan-zoom';
import IconComponent from './IconComponent';
  export default {
    name: 'HelloWorld',
    props: ['place'],
    components: {  SvgPanZoom, Compass },
    data: () => ({
      base_url: 'https://dy3fkqim66w1b.cloudfront.net/',
      finished: false,
      img_dim: {w: null, h: null},
      timePenalties: [ 0 ],
      loading: false,
      drawer2: false,
      dialogFinish: false,
      map: null,
      key: 'svg_0',
      rankings: [],
      dialogInfo: true,
      drawer: false,
      degree: 0,
      race_time: 0,
      transform: '',
      form: {pseudo: '', club: '', time: '', map: '', date: ''},
      feet: [],
      dist: 0,
      IconComponent: Vue.extend(IconComponent),
      started: false,
      panZoomRotateTiger: null,
      snack: false,
      meta: {},
      google: null,
      snackColor: '',
      dialog: false,
      snackText: '',
      sendRes: true,
      validations: {controls: [], start: undefined, finish: undefined},
      data: {start: undefined, finish: undefined, controls: []},
      dialogRes: false,
      markers: [],
      loadingRes: false,
      submittingRes: false,
      marker: null,
      panorama: null,
      svgpanzoom: null
    }),
    watch: {
      place: function(v) {
        this.loading = true;
        this.load(v);
      },
      dialogRes: function(v) {
        if (v) {
          this.loadingRes = true;
          let db  = firebase.firestore();
          let collection = db.collection('resultats').where('map','==', this.place)
          collection.get().then((snapshot)=> {
            this.rankings = snapshot.docs.map((d) =>{
              return d.data(); }  );
              this.rankings = this.rankings.sort((a,b) => { return a.time - b.time; })
            this.loadingRes = false;
          }).catch(() => {
            this.loadingRes = false;
          });
        }
      }
    },
    methods: {
      backToStart() {
          if (this.started && !this.finished) {
                      if (window.confirm(this.$t('back_to_start'))){
                        this.timePenalties.push(10*60);
                        this.panorama.setPosition(this.data.start.location);
                      }
                    } else {
                      alert(this.$t('be_in_race'));
                    }
      },
      reload() {
        if (window.confirm(this.$t('restart_all'))){
          this.reset();
        }
      },
      textPos(label, c) {
        //label x ou y
        let f = c.geo[label];
        let pos = '';
        let bonus = 0;
        let ope = '';
        let a = '';
        if (c.text_pos) {
          if (c.text_pos.length > 0 && c.text_pos.length < 3) {
            pos = c.text_pos;
          } else {
            pos = 'NE';
          }
        } else {
          pos = 'NE';
        }

        switch(pos) {
          case 'NW':
            a = '--';
          break;

          case 'N':
            a = '=-';
          break;

          case 'NE':
            a = '+-';
            bonus = -10;
          break;

          case 'E':
            a = '+=';
          break;

          case 'SE':
            a = '++';
          break;

          case 'S':
            a = '=+';

          break;

          case 'SW':
            a = '-+';
          break;

          case 'W':
            a = '-=';
            bonus = 40;
          break;
        }
        if (label == 'x') {
         ope = a[0];
       } else {
         ope = a[1];
       }
       let z = 0;
       if (ope == '+') {
         z= 1;
       } else if (ope == '-') {
         z = -1;
       }
       return (f + (40 * this.meta.text_ratio  * z + (z * bonus))) ;



     },
      coord(label, o, next) {
        if (next == undefined){
          next = this.data.finish;
        }
        let shape_line = shape("line", { x1: o.geo.x, y1: o.geo.y, x2: next.geo.x, y2: next.geo.y });
        let shape_circle = null
        if (label == "x1" || label=="y1"){
          shape_circle =  shape("circle", { cx: o.geo.x, cy: o.geo.y, r: (40 * this.meta.ratio) });
        }     else {
          shape_circle =  shape("circle", { cx: next.geo.x, cy: next.geo.y, r: (40 * this.meta.ratio) });
        }

        var intersections = intersect(shape_circle
      ,shape_line
   );

        //let eDistAtoB = Math.sqrt( Math.pow(next.geo.x - o.geo.x, 2) + Math.pow(next.geo.y -o.geo.y, 2) );
        //let dir = [ (next.geo.x - o.geo.x)/eDistAtoB, (next.geo.y -o.geo.y)/eDistAtoB ];
        //let t = (dir[0] * (c[0]-a[0])) + (d[1] * (c[1]-a[1]));
        if (label == "x1" || label == "x2") {
          return intersections.points[0].x;
        }
        if (label == "y1" || label == "y2") {
          return intersections.points[0].y;
        }



      },
      initMarkers() {
        const self = this;
        this.data.controls.forEach(c => {
          self.markers[c.order - 1] =  new self.google.maps.Marker({
            position: {lat: c.location.lat, lng: c.location.lng},
            map: null,
            icon: 'https://ogame-files.s3.eu-west-3.amazonaws.com/marker_control.png',
            //icon: 'https://scontent-mrs2-2.xx.fbcdn.net/v/t1.0-1/c156.0.320.320a/p320x320/95291700_101848891521969_1540878057844244480_o.jpg?_nc_cat=102&_nc_sid=1eb0c7&_nc_ohc=d3CBQY0KVeYAX9LsmJ5&_nc_ht=scontent-mrs2-2.xx&oh=1c8cd294f3054e288aa14fb1f770aa50&oe=5EE33C5A',
            //label: '◪',
            //icon: 'https://chart.apis.google.com/chart?chst=d_map_pin_icon&chld=cafe|FFFF00',
            title: ''+c.order+'',
            //icon: 'https://chart.apis.google.com/chart?chst=d_map_pin_icon&chld=dollar|FFFF00'
            //title: 'Bank'
          });

          self.markers[c.order - 1].addListener('click', (e) => {
            let m_pos = e.latLng.toJSON();
            let p_pos = self.panorama.getPosition().toJSON();

            if (self.distance(p_pos.lat, p_pos.lng, m_pos.lat, m_pos.lng, "K") < 0.012) {
                self.checkControl(c.order);
            } else {
              // pas assez proche
              self.snackText = self.$t('too_far');
              self.snackColor = "error";
              self.snack = true;
            }

            //let m_pos =
            //console.log(self.panorama.getPosition());

          });

        });


        let start = new self.google.maps.Marker({
          position: {lat:this.data.start.location.lat, lng: this.data.start.location.lng},
          map: this.map,
          icon: 'https://ogame-files.s3.eu-west-3.amazonaws.com/marker2_start.png',
          //icon: 'https://chart.apis.google.com/chart?chst=d_map_pin_icon&chld=cafe|FFFF00',
          title: 'Départ'
        }); 


     

        start.addListener('click', (e) => {
          let m_pos = e.latLng.toJSON();
          let p_pos = self.panorama.getPosition().toJSON();
          self.feet.push(e.latLng.toJSON());
          if (self.distance(p_pos.lat, p_pos.lng, m_pos.lat, m_pos.lng, "K") < 0.012) {
            self.start();
          } else {
            // pas assez proche
            self.snackText = self.$t('too_far');
            self.snackColor = "error";
            self.snack = true;
          }


        });

        let finish = new self.google.maps.Marker({
          position: {lat: this.data.finish.location.lat, lng: this.data.finish.location.lng},
          map: this.map,
          icon: 'https://ogame-files.s3.eu-west-3.amazonaws.com/marker2_finish.png',
          //icon: 'https://chart.apis.google.com/chart?chst=d_map_pin_icon&chld=cafe|FFFF00',
          title: 'Arrivée'
        });

        finish.addListener('click', (e) => {
          let m_pos = e.latLng.toJSON();
          let p_pos = self.panorama.getPosition().toJSON();

          if (self.distance(p_pos.lat, p_pos.lng, m_pos.lat, m_pos.lng, "K") < 0.012) {
            if (!self.finished) {
              self.finish();
            } else {
              self.snackText = self.$t('course_over_cannot_again');
              self.snackColor = "error";
              self.snack = true;
            }

          } else {
            // pas assez proche
            self.snackText = self.$t('too_far');
            self.snackColor = "error";
            self.snack = true;
          }
        });
      },
      submit() {
        this.submittingRes = true;
        this.form.map = this.place;
        this.form.time = this.race_time;
        this.form.dist = this.dist;
        this.form.date = new Date();
        let db = firebase.firestore();
        db.collection('resultats').doc().set(this.form).then(() => {
          this.submittingRes = false;
          this.dialogFinish = false;
        }).catch(() => {
          this.submittingRes = false;
          alert(this.$t('sorry_error'));
        });

      },
      getStartPoint(){
        let start_geo = this.data.start.geo;
        return [start_geo.x, start_geo.y - (30 * this.meta.ratio), start_geo.x - (30 * this.meta.ratio), start_geo.y + (30 * this.meta.ratio) ,start_geo.x + (30 * this.meta.ratio), start_geo.y + (30 * this.meta.ratio)].join(',');
      },
      finish() {
        if (this.started && this.data.controls.length  == this.validations.controls.length) {
          this.validations.finish = {time: new Date() };
          this.race_time = this.timePenalties.reduce((i,v) => v + i) + ((this.validations.finish.time - this.validations.start.time) / 1000);
          this.finished = true;
          this.snackText = this.$t('congrats_course_over');
          this.snackColor = "success";
          this.snack = true;
          this.dialogFinish = true;
        } else {
          this.snackText = this.$t('forget_controls');
          this.snackColor = "error";
          this.snack = true;
        }
      },
      registerSvgPanZoom(svgpanzoom) {
        this.svgpanzoom = svgpanzoom;
      },
      initMap() {
        const loader = new Loader('AIzaSyDreGT2CpjlKcExFi_7FXkqzP6E0pHU34w');
        const self = this;
        loader.load().then(function (google) {
          self.google = google;

          self.map = new google.maps.Map(document.getElementById('map'), {
            center: self.data.start.location,
            zoom: 8,
            panControl: false,
            addressControl: false,
            rotateControl: false,
            disableDefaultUI: true
          });

          self.initMarkers();
          //self.panZoomRotateTiger.enablePan();
          //self.panZoomRotateTiger.fit();
          //self.panZoomRotateTiger.updateBBox();
          //self.panZoomRotateTiger.fit();

          //self.panZoomRotateTiger.center();
          //self.panZoomRotateTiger.zoomBy(3);
          

          /*var centerControlDiv = document.createElement('div');
          var controlUI = document.createElement('div');
          controlUI.style.backgroundColor = '#1976d2';
           controlUI.style.border = '2px solid #fff';
           controlUI.style.borderRadius = '3px';
           controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
           controlUI.style.cursor = 'pointer';
           controlUI.style.marginBottom = '22px';
           controlUI.style.textAlign = 'center';
           controlUI.title = 'Click to recenter the map';

  */

        /*   var controlText = document.createElement('div');
              controlText.style.color = 'rgb(25,25,25)';
              controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
              controlText.style.fontSize = '16px';
   controlText.style.lineHeight = '38px';
   controlText.style.paddingLeft = '5px';
   controlText.style.paddingRight = '5px';
   controlText.innerHTML = '<div class="vue-icon"></div>';*/











  /*centerControlDiv[1].index = 3;
  centerControlDiv[2].index = 5;
  centerControlDiv[3].index = 7;
  centerControlDiv[4].index = 9;*/
          self.panorama = self.map.getStreetView({
              panControl: false,
              rotateControl: false,
              enableCloseButton: false, disableDefaultUI: true, linksControl: false, addressControl: false});

          self.panorama.setOptions({panControl: false, rotateControl: false});

          /*self.panorama.controls[google.maps.ControlPosition.LEFT_CENTER].push(centerControlDiv[1]);
          self.panorama.controls[google.maps.ControlPosition.LEFT_CENTER].push(centerControlDiv[2]);
          self.panorama.controls[google.maps.ControlPosition.LEFT_CENTER].push(centerControlDiv[3]);
          self.panorama.controls[google.maps.ControlPosition.LEFT_CENTER].push(centerControlDiv[4]);*/

          self.panorama.setPosition(self.data.start.location);
          self.panorama.setPov(({
            heading: self.meta.heading,
            pitch: 5
          }));
          self.degree = 360 - self.meta.heading;
          self.reset();
self.panorama.addListener('pov_changed', function() {
  self.degree = 360 - self.panorama.getPov().heading;
});
          self.panorama.addListener('position_changed', function() {
            if (self.started) {
              self.feet.push(self.panorama.getPosition().toJSON());
              if (self.dist != 0) {
                let last = self.feet[self.feet.length - 1];
                let before_last = self.feet[self.feet.length - 2];
                self.dist = self.dist + self.distance(last.lat, last.lng, before_last.lat, before_last.lng, 'K') * 1000;
              } else {
                let pano_pos = self.panorama.getPosition().toJSON();
                self.dist = self.distance(self.data.start.location.lat, self.data.start.location.lng, pano_pos.lat, pano_pos.lng, 'K') * 1000;
              }

              self.updateMarkersVisibility();
            }


          });
self.loading = false;
self.key = 'svg_'+Math.floor(Math.random() * Math.floor(50))
          self.panorama.setVisible(true);
        });
      },
      init(data) {
        this.dialog = true;
        this.meta = data;
        if (!this.meta.ratio) {
          this.meta.ratio = 1;
        }
        if (!this.meta.text_ratio) {
          this.meta.text_ratio = 1;
        }

        //this.data = {};
        const self = this;
        let i = new Image();
        i.onload = function() {

            self.img_dim.w = this.width;
            self.img_dim.h = this.height;
          }
        i.src = this.base_url+this.place+'/'+data.file;

        if (this.meta.course) {
          this.data = this.meta.course;
          this.initMap();
        } else {
          fetch(this.base_url+this.place+'/course.json').then(r => r.json()).then((d) => {
            self.data = d;
            self.initMap();
          });


        }






      },
      reset() {
        this.race_time = null;
        this.finished = false;

        this.started = false;
        this.form =  {email: '', pseudo: '', club: '', time: '', map: '', date: ''};
        this.validations = {controls: [], start: undefined, finish: undefined};
        this.timePenalties = [0];

        this.panorama.setPosition(this.data.start.location);
      },
      load(map) {

        let db  = firebase.firestore();
        db.collection('maps').doc(map).get().then((d) => {
          if (d.exists) {
            let map_data = d.data();

            if (map_data.enabled || (map_data.enabled == false && this.$route.query.key && this.$route.query.key == map_data.key)) {
              this.init(d.data());
            } else {
              alert(this.$t('place_disabled'));
            }

          } else {
            alert(this.$t('place_not_found') +' - 1');
          }
        }).catch(() => {
          // eslint-disable-next-line no-console
          //console.log(e);
          alert(this.$t('place_not_found') +' - 2');
        });
      },
      start() {
        // prevent restart abuse
          if (!this.started) {
            this.validations.start = {time: new Date() };
            this.started = true;
            this.snackText = this.$t('letsgo');
            this.snackColor = "success";
            this.snack = true;
            document.getElementById('img_canvas').removeAttribute('filter');
          }
      },
      checkControl(id) {
        if (this.validations.controls.length == id - 1) {
          this.validations.controls.push({id: id, time: new Date() });
          this.snackColor = "success";
          this.snackText = this.$t('control_ok');
          this.snack = true;
        } else {
          this.snackColor = "error";
          this.snackText = this.$t('control_ko');
          this.snack = true;
        }
      },
      updateMarkersVisibility() {
        let p = this.panorama.getPosition();
        this.markers.forEach(m => {
          let pos = m.getPosition();
          if (this.distance(p.lat(), p.lng(), pos.lat(), pos.lng(), "K") < 0.030) {
            m.setMap(this.map);
          }

        });

        //console.log(this.distance(p.lat(), p.lng(), m1.lat(), m1.lng(), "K"));
      },
      distance(lat1, lon1, lat2, lon2, unit) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
          return 0;
        }
        else {
          var radlat1 = Math.PI * lat1/180;
          var radlat2 = Math.PI * lat2/180;
          var theta = lon1-lon2;
          var radtheta = Math.PI * theta/180;
          var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
          if (dist > 1) {
            dist = 1;
          }
          dist = Math.acos(dist);
          dist = dist * 180/Math.PI;
          dist = dist * 60 * 1.1515;
          if (unit=="K") { dist = dist * 1.609344 }
          if (unit=="N") { dist = dist * 0.8684 }
          return dist;
        }
      }
    },
    mounted() {
      if (!this.place) {
        this.$router.push({name: 'Home', params:{place: 'reims'}})
      } else {
        this.load(this.place);
      }





},

  }
</script>
<style>
.controls-custom {
  position: absolute;
  right: 0;
  bottom: 50%;
}
.blur {
  filter: blur(10px);
  position: absolute;

}
#a1 {
  background-color: red;
}
.gm-iv-small-container  {
  display: none;
}
.gm-iv-address {
  display: none;
}
.validated {
  background-color: red;
}
#btn_toggle {
  position: absolute;
  z-index: 2000;
  top: 25px;
  left: 50%;
}
#map {
  height: 100%;
  width: 100%;
}

</style>
